import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/Icons/a_eur--sign.svg'
import _imports_1 from '@assets/img/Icons/buttons/arrow-diag.svg'
import _imports_2 from '@assets/img/Icons/buttons/plus.svg'
import _imports_3 from '@assets/img/Icons/buttons/trans.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-494d37c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accounts account_fields" }
const _hoisted_2 = { class: "title_box" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "account-section" }
const _hoisted_5 = { class: "account_balance" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_7 = { class: "ml-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "EUR", -1))
const _hoisted_9 = { class: "account_available_balance" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "euro" }, "€", -1))
const _hoisted_11 = { class: "account_btns" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "mr-3"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "mr-3"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "mr-3"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "mr-3"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_aba_button = _resolveComponent("aba-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$localization.getTranslate("MyAccount")), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.balance.Number), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$localization.getTranslate("AvailableBalance")), 1)
          ]),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, _toDisplayString(_ctx.balance.Balance), 1),
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_aba_button, {
          class: "active",
          btnSize: "",
          onClick: _ctx.transfer
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.$localization.getTranslate("Send money")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_aba_button, {
          class: "first",
          btnSize: "",
          onClick: _ctx.openReplenishAcquiring
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createTextVNode(" Top up by card ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_aba_button, {
          class: "first",
          btnSize: "",
          onClick: _ctx.openReplenish
        }, {
          default: _withCtx(() => [
            _hoisted_14,
            _createTextVNode(" Top up by transfer ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_aba_button, {
          class: "first",
          btnSize: "",
          onClick: _ctx.goToTransaction
        }, {
          default: _withCtx(() => [
            _hoisted_15,
            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Transactions")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}